const userDb = {
    results: [
        {
            gender: "female",
            name: {
                title: "ms",
                first: "susan",
                last: "diaz"
            },
            location: {
                street: "4729 w 6th st",
                city: "frederick",
                state: "south carolina",
                postcode: 85967,
                coordinates: {
                    latitude: "88.0612",
                    longitude: "86.5543"
                },
                timezone: {
                    offset: "+5:30",
                    description: "Bombay, Calcutta, Madras, New Delhi"
                }
            },
            email: "susan.diaz@example.com",
            login: {
                uuid: "e3bb7d5c-d48a-4665-8983-3567964563c0",
                username: "brownduck406",
                password: "kent",
                salt: "pGMyzudM",
                md5: "b3887943cc34bc5920a47ae4569a56ed",
                sha1: "70de98b6c9a16b0de025ea72ad4cfb2d274f9f08",
                sha256:
                    "549c6464087ebf3e5a2fb0ca411fe2c635875763f1d543a437ac45a7db88121e"
            },
            dob: {
                date: "1966-02-25T21:05:38Z",
                age: 53
            },
            registered: {
                date: "2009-09-11T12:52:36Z",
                age: 9
            },
            phone: "(323)-427-0096",
            cell: "(198)-141-0728",
            id: {
                name: "SSN",
                value: "806-59-6661"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/54.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/54.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/54.jpg"
            },
            nat: "US"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "lino",
                last: "rey"
            },
            location: {
                street: "4476 rue bataille",
                city: "montreuil",
                state: "moselle",
                postcode: 58669,
                coordinates: {
                    latitude: "-73.9978",
                    longitude: "160.4390"
                },
                timezone: {
                    offset: "+10:00",
                    description: "Eastern Australia, Guam, Vladivostok"
                }
            },
            email: "lino.rey@example.com",
            login: {
                uuid: "a2fe1720-b3ed-41a8-baaa-3707df768b86",
                username: "blackswan617",
                password: "green1",
                salt: "ARvoFswM",
                md5: "44eb0b41e53d7a045c738c14da7caa0b",
                sha1: "dfd7055b67c499b05fc940ca8a441ebaed31ba80",
                sha256:
                    "74dc755782312dc1eb0a4a1c52f2ed53a27eb8cb4a333b5a80a99e4e55a1ea4b"
            },
            dob: {
                date: "1972-04-05T17:16:32Z",
                age: 47
            },
            registered: {
                date: "2018-02-24T22:33:00Z",
                age: 1
            },
            phone: "04-99-52-38-49",
            cell: "06-40-68-87-84",
            id: {
                name: "INSEE",
                value: "1NNaN50061661 70"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/70.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/70.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/70.jpg"
            },
            nat: "FR"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "keimpe",
                last: "luiken"
            },
            location: {
                street: "9511 trans",
                city: "bloemendaal",
                state: "friesland",
                postcode: 11990,
                coordinates: {
                    latitude: "36.6337",
                    longitude: "-55.1700"
                },
                timezone: {
                    offset: "-11:00",
                    description: "Midway Island, Samoa"
                }
            },
            email: "keimpe.luiken@example.com",
            login: {
                uuid: "3845962e-98fb-4aef-845d-7e60addcd791",
                username: "bigmouse953",
                password: "kitty",
                salt: "49u8ZGqW",
                md5: "3e2e5161ea4e64a6680d3ebc77e1e6ee",
                sha1: "34e89fd728a99376935e8206ad14113e0b147da0",
                sha256:
                    "a4980b7a44b69543823f656ea35e071157a89d582ffaf9d1ce6db4ab4639ab3d"
            },
            dob: {
                date: "1985-01-29T19:19:57Z",
                age: 34
            },
            registered: {
                date: "2010-11-24T03:51:19Z",
                age: 8
            },
            phone: "(873)-611-8941",
            cell: "(275)-371-9575",
            id: {
                name: "BSN",
                value: "97087440"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/6.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/6.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/6.jpg"
            },
            nat: "NL"
        },
        {
            gender: "female",
            name: {
                title: "ms",
                first: "ece",
                last: "akşit"
            },
            location: {
                street: "1258 fatih sultan mehmet cd",
                city: "niğde",
                state: "ordu",
                postcode: 45747,
                coordinates: {
                    latitude: "-85.2280",
                    longitude: "45.1670"
                },
                timezone: {
                    offset: "-1:00",
                    description: "Azores, Cape Verde Islands"
                }
            },
            email: "ece.akşit@example.com",
            login: {
                uuid: "2aa2c0b5-871f-4d12-8ef5-fd84c81afc81",
                username: "bigpanda866",
                password: "fortress",
                salt: "NIZboH3u",
                md5: "bd16e9408aaa476d3f0280104f5f907b",
                sha1: "e37f84938b45f9fbf259dfb9a3ed1f9eb173cd89",
                sha256:
                    "c87ff4bde80b2aac49cd6b1ae91cafc98f27ef771458d71464b3587861804339"
            },
            dob: {
                date: "1976-01-08T23:31:09Z",
                age: 43
            },
            registered: {
                date: "2015-04-14T15:27:23Z",
                age: 4
            },
            phone: "(329)-999-9512",
            cell: "(683)-467-2083",
            id: {
                name: "",
                value: null
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/23.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/23.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/23.jpg"
            },
            nat: "TR"
        },
        {
            gender: "female",
            name: {
                title: "mrs",
                first: "pauline",
                last: "wheeler"
            },
            location: {
                street: "3577 westheimer rd",
                city: "milwaukee",
                state: "missouri",
                postcode: 35531,
                coordinates: {
                    latitude: "66.0716",
                    longitude: "77.5188"
                },
                timezone: {
                    offset: "-4:00",
                    description: "Atlantic Time (Canada), Caracas, La Paz"
                }
            },
            email: "pauline.wheeler@example.com",
            login: {
                uuid: "5a21ef72-4c95-4b3e-8b8f-b1db660ee61b",
                username: "smallgorilla931",
                password: "northern",
                salt: "7cC5DYhe",
                md5: "3f10013b8dfd16d92d9121fe1f0e86c0",
                sha1: "bbf6fb1424f2bd338e1a65c3a4468d99ba99c35a",
                sha256:
                    "a8c3e9eebff4404163636ada2c333f5501fd33371e2b974b4877b3ad284384e0"
            },
            dob: {
                date: "1960-08-14T04:39:32Z",
                age: 58
            },
            registered: {
                date: "2011-06-06T09:29:41Z",
                age: 8
            },
            phone: "(217)-955-5227",
            cell: "(249)-345-8645",
            id: {
                name: "SSN",
                value: "902-53-9993"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/92.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/92.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/92.jpg"
            },
            nat: "US"
        },
        {
            gender: "female",
            name: {
                title: "miss",
                first: "felícia",
                last: "pinto"
            },
            location: {
                street: "9940 rua rio de janeiro ",
                city: "caraguatatuba",
                state: "ceará",
                postcode: 59141,
                coordinates: {
                    latitude: "-16.5152",
                    longitude: "-134.7170"
                },
                timezone: {
                    offset: "-7:00",
                    description: "Mountain Time (US & Canada)"
                }
            },
            email: "felícia.pinto@example.com",
            login: {
                uuid: "caa6a8d0-38e5-451b-99c3-54feeff924ad",
                username: "lazybutterfly708",
                password: "birthday4",
                salt: "Dt1nDlnT",
                md5: "22e19aa831ae376571c1c6bd7c1eb22d",
                sha1: "6bd3b034ffb1a7c592d4827ae944d0171e0d4ae3",
                sha256:
                    "e95d2c9057997447597b2f41c5b9e557e3d879a05dc59a3e1c436a235c4343e3"
            },
            dob: {
                date: "1953-01-20T12:40:49Z",
                age: 66
            },
            registered: {
                date: "2018-05-31T09:14:46Z",
                age: 1
            },
            phone: "(81) 9801-5294",
            cell: "(24) 6873-7158",
            id: {
                name: "",
                value: null
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/0.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/0.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/0.jpg"
            },
            nat: "BR"
        },
        {
            gender: "female",
            name: {
                title: "ms",
                first: "nicole",
                last: "foster"
            },
            location: {
                street: "7453 mockingbird ln",
                city: "west palm beach",
                state: "connecticut",
                postcode: 88924,
                coordinates: {
                    latitude: "-33.7753",
                    longitude: "-32.0030"
                },
                timezone: {
                    offset: "+6:00",
                    description: "Almaty, Dhaka, Colombo"
                }
            },
            email: "nicole.foster@example.com",
            login: {
                uuid: "ab40d5fd-cf54-45f8-b4f0-7e7d21ac6e49",
                username: "lazygoose210",
                password: "pistol",
                salt: "rkaMQJ1U",
                md5: "cb7185798be3d863b372b6bac5054c70",
                sha1: "0359a1028d9fa60e8e15dd4d4a0f5291b05ce4be",
                sha256:
                    "cda7cf99b16efc5a2d6899f804a70906cf8a4e979324296a73db8cd466052f2e"
            },
            dob: {
                date: "1992-05-29T10:59:31Z",
                age: 27
            },
            registered: {
                date: "2011-11-17T12:16:31Z",
                age: 7
            },
            phone: "(274)-471-5029",
            cell: "(869)-842-8091",
            id: {
                name: "SSN",
                value: "834-43-0380"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/2.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/2.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/2.jpg"
            },
            nat: "US"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "marin",
                last: "nguyen"
            },
            location: {
                street: "766 place du 22 novembre 1943",
                city: "argenteuil",
                state: "aveyron",
                postcode: 43466,
                coordinates: {
                    latitude: "82.1813",
                    longitude: "-78.0525"
                },
                timezone: {
                    offset: "-11:00",
                    description: "Midway Island, Samoa"
                }
            },
            email: "marin.nguyen@example.com",
            login: {
                uuid: "1bf89943-c37e-4668-9a69-f1485eef5085",
                username: "yellowbear872",
                password: "jagger",
                salt: "7mCbRwNT",
                md5: "69385a6d283cf927f2563b4a9f429cc3",
                sha1: "29a53759ae10729f181e58e883d6b10ad4e436a4",
                sha256:
                    "ce0d41af53e25fd11772348ae4686161afe912b0b90d0a2e0ef61607685a8054"
            },
            dob: {
                date: "1953-06-13T08:28:09Z",
                age: 66
            },
            registered: {
                date: "2006-05-09T20:56:39Z",
                age: 13
            },
            phone: "02-04-19-49-23",
            cell: "06-83-33-36-76",
            id: {
                name: "INSEE",
                value: "1NNaN72019043 40"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/97.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/97.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/97.jpg"
            },
            nat: "FR"
        },
        {
            gender: "female",
            name: {
                title: "madame",
                first: "flurina",
                last: "guerin"
            },
            location: {
                street: "7710 rue de l'abbé-rousselot",
                city: "personico",
                state: "basel-stadt",
                postcode: 9806,
                coordinates: {
                    latitude: "49.4852",
                    longitude: "-116.1602"
                },
                timezone: {
                    offset: "+5:30",
                    description: "Bombay, Calcutta, Madras, New Delhi"
                }
            },
            email: "flurina.guerin@example.com",
            login: {
                uuid: "3f933875-d372-43b2-81a2-f0d2ed1293e7",
                username: "brownswan811",
                password: "roadkill",
                salt: "JJU1GXMV",
                md5: "b98936020e57e8c0e9fbec3aa4647015",
                sha1: "03c09d9670ee9cb1bd3f0d284955fc659203beb8",
                sha256:
                    "44bd3e44726bd654575e02cc0468e91e56eae9707496014d35de6dc044245197"
            },
            dob: {
                date: "1976-07-17T13:59:21Z",
                age: 42
            },
            registered: {
                date: "2005-11-02T04:01:07Z",
                age: 13
            },
            phone: "(362)-051-0536",
            cell: "(677)-995-6304",
            id: {
                name: "AVS",
                value: "756.8138.4515.75"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/85.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/85.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/85.jpg"
            },
            nat: "CH"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "ali",
                last: "körmükçü"
            },
            location: {
                street: "2987 anafartalar cd",
                city: "aksaray",
                state: "ağrı",
                postcode: 62277,
                coordinates: {
                    latitude: "-41.6201",
                    longitude: "-16.7193"
                },
                timezone: {
                    offset: "-11:00",
                    description: "Midway Island, Samoa"
                }
            },
            email: "ali.körmükçü@example.com",
            login: {
                uuid: "9dc5b38c-fab4-4dcb-8f2e-4209a9dbb751",
                username: "organicgorilla214",
                password: "beacon",
                salt: "0RQgdbfl",
                md5: "72450b461507d7ecd035c8aa8034beab",
                sha1: "ca3a020ad19a224cfb5d80fb5f58de3409da3d54",
                sha256:
                    "87de685ce20952268df3e3c5775e54e89deb1694b76d902928d9b976c6bc4a43"
            },
            dob: {
                date: "1960-06-21T06:15:53Z",
                age: 59
            },
            registered: {
                date: "2013-12-08T11:25:10Z",
                age: 5
            },
            phone: "(888)-538-1577",
            cell: "(971)-863-2072",
            id: {
                name: "",
                value: null
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/52.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/52.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/52.jpg"
            },
            nat: "TR"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "hector",
                last: "bonnet"
            },
            location: {
                street: "8974 boulevard de balmont",
                city: "marseille",
                state: "loire-atlantique",
                postcode: 90096,
                coordinates: {
                    latitude: "72.7387",
                    longitude: "34.1144"
                },
                timezone: {
                    offset: "-11:00",
                    description: "Midway Island, Samoa"
                }
            },
            email: "hector.bonnet@example.com",
            login: {
                uuid: "03c77c38-14ed-4bfd-b3d1-f2d566505d18",
                username: "lazyostrich310",
                password: "done",
                salt: "Q1hDRbIU",
                md5: "5c7beb4e90045fcf820d59360e59a6ee",
                sha1: "da49af2a8ccb647eea5810b5ab5861cf77e2dfd1",
                sha256:
                    "e7258187a6e701e997fd245f8ba12d05088b9fa910a0a23b9f3ad5d669c71977"
            },
            dob: {
                date: "1992-10-31T11:26:54Z",
                age: 26
            },
            registered: {
                date: "2011-07-18T08:32:40Z",
                age: 7
            },
            phone: "05-09-96-23-65",
            cell: "06-05-13-95-28",
            id: {
                name: "INSEE",
                value: "1NNaN11715245 52"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/36.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/36.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/36.jpg"
            },
            nat: "FR"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "mads",
                last: "christiansen"
            },
            location: {
                street: "6104 hærvejen",
                city: "silkeboeg",
                state: "danmark",
                postcode: 82044,
                coordinates: {
                    latitude: "-75.9854",
                    longitude: "39.5323"
                },
                timezone: {
                    offset: "+9:00",
                    description: "Tokyo, Seoul, Osaka, Sapporo, Yakutsk"
                }
            },
            email: "mads.christiansen@example.com",
            login: {
                uuid: "b014015f-370b-45ab-bf0d-24f6172f7f35",
                username: "lazywolf149",
                password: "giorgio",
                salt: "swiZJIJM",
                md5: "e78c91146d07ca856864ac617d181efb",
                sha1: "65cccc94af77b1490d4041c2841883b6f57150af",
                sha256:
                    "cdca15c9e5fbd40008e87e6cc8afa9dab4fccaad0e40f04325b116100073f1f2"
            },
            dob: {
                date: "1979-09-19T03:30:29Z",
                age: 39
            },
            registered: {
                date: "2013-01-12T00:16:57Z",
                age: 6
            },
            phone: "08568966",
            cell: "85059368",
            id: {
                name: "CPR",
                value: "751215-9952"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/7.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/7.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/7.jpg"
            },
            nat: "DK"
        },
        {
            gender: "female",
            name: {
                title: "ms",
                first: "abigail",
                last: "sirko"
            },
            location: {
                street: "3429 tecumseh rd",
                city: "chesterville",
                state: "british columbia",
                postcode: "G7Q 6F2",
                coordinates: {
                    latitude: "70.7913",
                    longitude: "-66.8299"
                },
                timezone: {
                    offset: "+1:00",
                    description: "Brussels, Copenhagen, Madrid, Paris"
                }
            },
            email: "abigail.sirko@example.com",
            login: {
                uuid: "5559cab3-12f0-4756-83d5-6abc9a2399bd",
                username: "ticklishmeercat378",
                password: "nevets",
                salt: "V78LTOPA",
                md5: "a360126243f0298118629666d46263cd",
                sha1: "f7e7fa42e13ec4a87fe55ab375e71ef4164b5861",
                sha256:
                    "ff1023c00e01fa09c1caa90a40ef353ea67ba9cb798c5b872030a38c772034dc"
            },
            dob: {
                date: "1952-03-16T20:30:47Z",
                age: 67
            },
            registered: {
                date: "2004-11-16T04:18:24Z",
                age: 14
            },
            phone: "515-743-0665",
            cell: "476-333-1589",
            id: {
                name: "",
                value: null
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/45.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/45.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/45.jpg"
            },
            nat: "CA"
        },
        {
            gender: "female",
            name: {
                title: "miss",
                first: "anna",
                last: "habte"
            },
            location: {
                street: "sundveien 1669",
                city: "balestrand",
                state: "sogn og fjordane",
                postcode: "1790",
                coordinates: {
                    latitude: "3.4192",
                    longitude: "107.1285"
                },
                timezone: {
                    offset: "-6:00",
                    description: "Central Time (US & Canada), Mexico City"
                }
            },
            email: "anna.habte@example.com",
            login: {
                uuid: "9cc3dc93-ecf5-4a40-9208-5abcbee8a506",
                username: "crazyelephant598",
                password: "scandinavian",
                salt: "s4xcBdMS",
                md5: "fc9f05867df9d2a0494ebc64898ab90b",
                sha1: "e4d47d47ef87de24b8dd7b011cf26e2a0b14d8f6",
                sha256:
                    "2b7a21e755a44d0b32c5182b1b4eb2d961c8d4a8426aac7e9153e0a3b6a3f148"
            },
            dob: {
                date: "1963-02-13T20:07:19Z",
                age: 56
            },
            registered: {
                date: "2007-02-26T06:21:04Z",
                age: 12
            },
            phone: "81020943",
            cell: "43636437",
            id: {
                name: "FN",
                value: "13026343784"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/47.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/47.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/47.jpg"
            },
            nat: "NO"
        },
        {
            gender: "female",
            name: {
                title: "ms",
                first: "jesus",
                last: "martinez"
            },
            location: {
                street: "6584 calle de bravo murillo",
                city: "mérida",
                state: "región de murcia",
                postcode: 25997,
                coordinates: {
                    latitude: "62.1716",
                    longitude: "-137.2321"
                },
                timezone: {
                    offset: "+3:30",
                    description: "Tehran"
                }
            },
            email: "jesus.martinez@example.com",
            login: {
                uuid: "5d6819b8-e509-4141-909f-ba1001219624",
                username: "organictiger622",
                password: "fish",
                salt: "Co45K5x9",
                md5: "47326f75feb80c7ed9e5d84cf17b118c",
                sha1: "67f2cb643fdc99c849f454690d45a976c8457ee6",
                sha256:
                    "fac89e9f7d6a8b7a2298907a2622f24319745459c3e0db1dcd684364b4b7a292"
            },
            dob: {
                date: "1949-07-19T00:05:42Z",
                age: 69
            },
            registered: {
                date: "2008-09-06T05:49:16Z",
                age: 10
            },
            phone: "984-458-306",
            cell: "660-605-597",
            id: {
                name: "DNI",
                value: "28838963-X"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/6.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/6.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/6.jpg"
            },
            nat: "ES"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "çetin",
                last: "akay"
            },
            location: {
                street: "5242 vatan cd",
                city: "ankara",
                state: "niğde",
                postcode: 20317,
                coordinates: {
                    latitude: "39.8721",
                    longitude: "9.5152"
                },
                timezone: {
                    offset: "+8:00",
                    description: "Beijing, Perth, Singapore, Hong Kong"
                }
            },
            email: "çetin.akay@example.com",
            login: {
                uuid: "ded85c28-ccec-42da-930c-383510e279eb",
                username: "orangepeacock940",
                password: "ashlee",
                salt: "0drfKRrJ",
                md5: "3454c71c291f914df4120ecf3aa75875",
                sha1: "d4ebdafaa20cfdd34620bf376a72a66d9e490d60",
                sha256:
                    "b23b573667a9fd3949404b28b59b20e5de09e1280e8624c437a8ab634837893e"
            },
            dob: {
                date: "1950-01-11T23:44:58Z",
                age: 69
            },
            registered: {
                date: "2002-09-11T13:45:10Z",
                age: 16
            },
            phone: "(875)-077-6823",
            cell: "(387)-908-2848",
            id: {
                name: "",
                value: null
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/11.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/11.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/11.jpg"
            },
            nat: "TR"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "mikkel",
                last: "orvik"
            },
            location: {
                street: "øvre skjoldvei 7864",
                city: "hattfjelldal",
                state: "hedmark",
                postcode: "2718",
                coordinates: {
                    latitude: "62.3171",
                    longitude: "-139.1600"
                },
                timezone: {
                    offset: "+9:30",
                    description: "Adelaide, Darwin"
                }
            },
            email: "mikkel.orvik@example.com",
            login: {
                uuid: "7b08c48b-3e95-4d0e-b935-b81925f83d21",
                username: "biggoose745",
                password: "matrix",
                salt: "fpdxepFN",
                md5: "f38508f3b3ba12604051da05e13c0279",
                sha1: "4bc2e487731e80751eac0d48fa8b398b5b6b5e18",
                sha256:
                    "dfed1848e54ceadd1ba19876cc61fcdefb5364cb1d1b71ab4eb7826ed224e596"
            },
            dob: {
                date: "1996-03-07T16:04:50Z",
                age: 23
            },
            registered: {
                date: "2011-04-30T18:20:34Z",
                age: 8
            },
            phone: "53050897",
            cell: "90696901",
            id: {
                name: "FN",
                value: "07039642802"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/58.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/58.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/58.jpg"
            },
            nat: "NO"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "christopher",
                last: "ruiz"
            },
            location: {
                street: "8883 w dallas st",
                city: "bendigo",
                state: "new south wales",
                postcode: 1158,
                coordinates: {
                    latitude: "48.3759",
                    longitude: "-114.1694"
                },
                timezone: {
                    offset: "+9:30",
                    description: "Adelaide, Darwin"
                }
            },
            email: "christopher.ruiz@example.com",
            login: {
                uuid: "83788445-81e9-45b1-8452-d989968f0aa1",
                username: "smallpanda254",
                password: "southpar",
                salt: "5aBSNHRC",
                md5: "ab3e16aa5919b0c0c3e62813bfc60c92",
                sha1: "c697a67a767ad23cfb6fa728fa92cb1c728021f5",
                sha256:
                    "f3c37753826f7ad6eb8129a8884a92579796927853a2386addde2ce13fe64ec5"
            },
            dob: {
                date: "1996-10-24T19:17:28Z",
                age: 22
            },
            registered: {
                date: "2006-08-31T04:58:29Z",
                age: 12
            },
            phone: "06-7745-5273",
            cell: "0402-360-501",
            id: {
                name: "TFN",
                value: "352101829"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/62.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/62.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/62.jpg"
            },
            nat: "AU"
        },
        {
            gender: "male",
            name: {
                title: "mr",
                first: "lucas",
                last: "jørgensen"
            },
            location: {
                street: "2889 nyvangsvej",
                city: "gjerlev",
                state: "midtjylland",
                postcode: 46642,
                coordinates: {
                    latitude: "-78.6569",
                    longitude: "132.6407"
                },
                timezone: {
                    offset: "-10:00",
                    description: "Hawaii"
                }
            },
            email: "lucas.jørgensen@example.com",
            login: {
                uuid: "9adeb9e9-18f5-4adb-9232-8ff942f0db75",
                username: "bluemouse184",
                password: "theforce",
                salt: "ONbeENm0",
                md5: "49a8fad06f4e277f0da0f26d198c1d40",
                sha1: "4a8a4078ce002c4f96025b857a7a9b7358808057",
                sha256:
                    "c3cd67dafd5407f984e1b59d63427b1756b217c5f8ec7b9271a76705f3cf296f"
            },
            dob: {
                date: "1958-02-23T16:51:40Z",
                age: 61
            },
            registered: {
                date: "2008-12-21T08:02:34Z",
                age: 10
            },
            phone: "80436572",
            cell: "82910112",
            id: {
                name: "CPR",
                value: "374908-7000"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/men/51.jpg",
                medium: "https://randomuser.me/api/portraits/med/men/51.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/men/51.jpg"
            },
            nat: "DK"
        },
        {
            gender: "female",
            name: {
                title: "ms",
                first: "dana",
                last: "payne"
            },
            location: {
                street: "7097 mcgowen st",
                city: "port st. lucie",
                state: "tennessee",
                postcode: 91586,
                coordinates: {
                    latitude: "70.6007",
                    longitude: "-114.2235"
                },
                timezone: {
                    offset: "-2:00",
                    description: "Mid-Atlantic"
                }
            },
            email: "dana.payne@example.com",
            login: {
                uuid: "12cff9ba-a6ad-4942-a792-8b6519997b95",
                username: "bluelion845",
                password: "graves",
                salt: "Uqf9bU9Q",
                md5: "13b6915cb6140445fb873064e03a6184",
                sha1: "4f4c955feaa75ba8500c63488454bdec1db35cdc",
                sha256:
                    "6e9298e850c908b98278ee7061cf7d766b6a41a11b32c8494b6495d06a343b14"
            },
            dob: {
                date: "1991-09-06T05:39:50Z",
                age: 27
            },
            registered: {
                date: "2003-08-28T22:04:51Z",
                age: 15
            },
            phone: "(040)-043-6821",
            cell: "(445)-534-3493",
            id: {
                name: "SSN",
                value: "536-43-2929"
            },
            picture: {
                large: "https://randomuser.me/api/portraits/women/3.jpg",
                medium: "https://randomuser.me/api/portraits/med/women/3.jpg",
                thumbnail: "https://randomuser.me/api/portraits/thumb/women/3.jpg"
            },
            nat: "US"
        }
    ],
    info: {
        seed: "253718ec092ad3da",
        results: 20,
        page: 1,
        version: "1.2"
    }
};

const createProfile = userDb.results.map((u, i) => {
    return {
        id: i,
        name: `${u.name.title}. ${u.name.first} ${u.name.last}`.toUpperCase(),
        email: u.email,
        phone: u.phone,
        profilePic: u.picture.medium
    };
});

const getUsers = () =>
    new Promise(resolve => setTimeout(() => resolve(createProfile), 1500));

export default getUsers;









// Movie DataBase
export const movies = [
    { id: "2353", movie_title: "The Hanoi Hilton", movie_genre: "Drama|War" },
    { id: "518", movie_title: "American Teen", movie_genre: "Documentary" },
    {
        id: "1299",
        movie_title: "Monster, The (Mostro, Il)",
        movie_genre: "Comedy"
    },
    {
        id: "601",
        movie_title: "What Have I Done to Deserve This?",
        movie_genre: "Comedy|Drama"
    },
    {
        id: "232",
        movie_title: "World on a Wire",
        movie_genre: "Crime|Sci-Fi"
    },
    { id: "789", movie_title: "Bad Boy Bubby", movie_genre: "Drama" },
    {
        id: "2658",
        movie_title: "Cuenca Crime",
        movie_genre: "Drama"
    },
    { id: "2980", movie_title: "Blue Sunshine", movie_genre: "Horror|Thriller" },
    {
        id: "560",
        movie_title: "Men with Brooms",
        movie_genre: "Comedy|Drama|Romance"
    },
    {
        id: "479",
        movie_title: "Avenging Angelo",
        movie_genre: "Action|Comedy|Crime"
    }
];
